<template>
  <v-container id="beneficios" fluid class="black py-0">
    <v-row class="py-10">
      <v-col cols="12" md="8"
        class="pt-8 pb-12"
        :class="{
          'px-12': $vuetify.breakpoint.mdAndUp,
          'px-8': $vuetify.breakpoint.smAndDown,
        }"
      >
        <h3 class="body-1 font-weight-regular pt-3">
          <span class="poppins primary--text">mude sua vida</span>
        </h3>
        <h2 class="display-1 font-weight-bold pt-1">
          <span class="barlow white--text">QUE TRANSFORMAÇÕES VOCÊ IRÁ REALIZAR?</span>
        </h2>
        <v-divider class="primary my-4" style="width: 50px; border: 2px solid"></v-divider>
        <div class="body-1 font-weight-light pt-1">
          <span class="poppins grey--text text--lighten-2">Mudando a si mesmo, você muda seus resultados: a qualidade dos seus relacionamentos, a realização de seus projetos e sua experiência de vida!</span>
        </div>
        <v-row>
          <v-col 
            cols="12" md="6"
            v-for="(c,i) in cards" :key="i"
          >
            <v-card class="text-center pa-4 fill-height">
              <v-icon class="d-flex" color="primary">{{c.icone}}</v-icon>
              <div class="headline pt-3 font-weight-regular primary--text text-uppercase">
                <span class="barlow">{{c.titulo}}</span>
              </div>
              <div class="body-1 pt-3 font-weight-regular black--text">
                <span class="roboto">{{c.descricao}}</span>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="4" class="hidden-sm-and-down">
        <v-img
          class="fill-height" 
          :src="getImgUrl(imagem)"
        ></v-img>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      imagem: 'dark.jpg',
      cards: [
        {
          icone: 'mdi-account-heart',
          titulo: 'AUTOLIDERANÇA E INTELIGÊNCIA EMOCIONAL',
          descricao: 'Aumentar sua capacidade de gerir suas emoções'
        },
        {
          icone: 'mdi-compass',
          titulo: 'DECISÕES MAIS ASSERTIVAS E EFICAZES',
          descricao: 'Aprender a decidir baseado no seu propósito e missão de vida'
        },
        {
          icone: 'mdi-account-group',
          titulo: 'MELHORAR SEU RELACIONAMENTO CONSIGO MESMO E COM OS AS OUTRAS PESSOAS',
          descricao: 'Através do autoconhecimento e autocompaixão, melhoramos significativamente nossos relacionamentos'
        },
        {
          icone: 'mdi-trophy',
          titulo: 'CAPACIDADE PARA IDENTIFICAR E ALTERAR COMPORTAMENTOS SABOTAM SUCESSO',
          descricao: 'Compreender os mecanismos inconscientes (sabotadores) que impedem o teu crescimento pessoal e profissional'
        },
      ]
    }
  },
  methods: {
    getImgUrl(i) {
      return require('../assets/img/'+i)
    },
  }
}
</script>